import React from 'react'
import Button from './Button'

const ButtonLogin = (props) => {
  return (
    <Button
      color="bar"
      icon="VpnKey"
      {...props}
    />
  )
}

export default ButtonLogin
